import AddEditSection from "../../components/AddEditSection";
import Breadcrumb from "../../parts/Breadcrumb";
import React, { useState, useEffect } from "react";
import configuration from "../../config";
import { toast } from "react-toastify";
import labels from "../../constants/Language";
import _ from 'underscore'
// For Add Language
function Add({ history }) {
  const statusOpt = [
    // 
    { id: 1, title: "Active", value: "active" },
    { id: 2, title: "Inactive", value: "inactive" },
    { id: 3, title: "Archive", value: "archive" },
  ];
  const [fieldArr, setFieldArr] = useState([
    { id: 0, title: "Title", name: "title", type: "TextInput" },
    { id: 1, title: "Code", name: "code", type: "TextInput" },

    {
      id: 3,
      title: "Status",
      name: "status",
      type: "Dropdown",
      options: statusOpt,
    },
  ]);


  const [fields, setFields] = useState({});
  const [errors, setErrors] = useState({
    title: "",
    code: "",
  });


  function handleValidation() {
    let flag = true;
    let error = {}
    if (!fields.title) {
      error['title'] = "Please enter language title"
      flag = false
    }

    if (!fields.code) {
      error['code'] = "Please enter language Code"
      flag = false
    }
    if (!fields.status) {
      error['status'] = "Please select status"
      flag = false
    }
    // console.log(error)
    setErrors({ ...error })
    return flag;
  }

  useEffect(() => {
    configuration.getAPI({ url: 'common/list-order-no', params: { collectionName: 'languages', lang_code: "EN" } }).then((data) => {
      if (data.status === 200) {
        let orderNoArr = []
        _.each(data.payload, (singleRec) => {
          orderNoArr.push({ 'title': singleRec.title, 'value': singleRec.order_no, 'id': singleRec.order_no })
        })
        const orderNoObj = {
          id: 1,
          title: "Order No",
          name: "order_no",
          type: "Dropdown",
          options: orderNoArr,
        }
        fieldArr.push(orderNoObj)
        setFieldArr([...fieldArr])
      }
    }).catch(error => {
      return toast.error(error.message)
    });


  }, []);

  const handleSubmit = () => {
    if (handleValidation()) {

      configuration
        .postAPI({ url: "language/create", params: fields })
        .then((data) => {
          if (data.status === 200) {
            history.push("/language");

            // history.push({ pathname: "/language", state: { is_added: true } });
          } else if (data.error) {
            return toast.error(data.error.message);
          } else {
            return toast.error("Something went wrong");
          }
        })
        .catch((error) => {
          return toast.error(error.message);
        });
    }
  };

  function handleChange(field, e) {
    setFields({ ...fields, [field]: e.target.value });
  }

  return (
    <>
      <Breadcrumb module={labels.addLanguage} />

      <AddEditSection
        title="Add Language"
        path="/language"
        fields={fieldArr}
        fieldError={errors}
        fieldValue={fields}
        handleChange={handleChange}
        handleSubmit={handleSubmit}
      />
    </>
  );
}

export default Add;
